import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  InfoSection,
  InfoTitle,
  InfoItem,
  ClickableOrganizer // Nuovo styled component
} from '../styles/EventSidebar.styles';

const EventInfo = ({ event }) => {
  const navigate = useNavigate();

  // Helper per ottenere i dati dell'organizzatore
  const getOrganizerData = () => {
    // Prima controlla se c'è un organizzatore alternativo (stringa)
    if (event.alternativeOrganizer) {
      return {
        name: event.alternativeOrganizer,
        id: null,
        type: 'alternative'
      };
    }
    
    // Poi controlla se ci sono organizzatori (relazione con users)
    if (event.organizers && event.organizers.length > 0) {
      const organizer = event.organizers[0]; // Prendi il primo organizzatore
      
      // In Strapi v5, i dati potrebbero essere già popolati o avere structure diversa
      return {
        name: organizer.username || organizer.email || 'Organizzatore',
        id: organizer.id,
        type: 'user'
      };
    }
    
    return null;
  };

  // Funzione per gestire il click sull'organizzatore
  const handleOrganizerClick = () => {
    const organizerData = getOrganizerData();
    
    if (!organizerData) return;

    if (organizerData.type === 'user' && organizerData.id) {
      // Naviga alla pagina dell'organizzatore con ID
      navigate(`/organizzatore/${organizerData.id}`);
    } else if (organizerData.type === 'alternative') {
      // Per organizzatori alternativi, fai una ricerca per nome
      navigate(`/organizzatore/search?name=${encodeURIComponent(organizerData.name)}`);
    }
  };

  const organizerData = getOrganizerData();

  return (
    <InfoSection>
      <InfoTitle>Informazioni</InfoTitle>
      
      {organizerData && (
        <InfoItem>
          <strong>Organizzatore:</strong>
          <ClickableOrganizer onClick={handleOrganizerClick}>
            {organizerData.name}
          </ClickableOrganizer>
        </InfoItem>
      )}
      
      {event.url && (
        <InfoItem>
          <strong>Sito web:</strong>
          <a 
            href={event.url.startsWith('http') ? event.url : `https://${event.url}`} 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: '#007bff', textDecoration: 'underline' }}
          >
            {event.url}
          </a>
        </InfoItem>
      )}
      
      {event.phone && (
        <InfoItem>
          <strong>Telefono:</strong>
          <a 
            href={`tel:${event.phone}`}
            style={{ color: '#007bff', textDecoration: 'underline' }}
          >
            {event.phone}
          </a>
        </InfoItem>
      )}
      
      {event.email && (
        <InfoItem>
          <strong>Email:</strong>
          <a 
            href={`mailto:${event.email}`}
            style={{ color: '#007bff', textDecoration: 'underline' }}
          >
            {event.email}
          </a>
        </InfoItem>
      )}
            {event.ticketPrice !== undefined && event.ticketPrice !== null && (
        <InfoItem>
          <strong>Prezzo:</strong>
          {event.ticketPrice === 0 ? '' : `€ ${event.ticketPrice}`}
        </InfoItem>
      )}
      
      {/* Mostra se l'evento è scaduto */}
      {event.isExpired && (
        <InfoItem>
          <strong>Stato:</strong>
          <span style={{ color: '#e74c3c' }}>Evento terminato</span>
        </InfoItem>
      )}
    </InfoSection>
  );
};

export default EventInfo;

      